import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { deleteEmailSchedulesFromAPI, fetchEmailSchedulesFromAPI, uploadEmailScheduleFileToAPI } from "../../../services/EmailScheduleService";


export const fetchEmailSchedules = createAsyncThunk(
  "emailSchedules/fetchEmailSchedules",
  async ({ page, perPage, search, columnFilters, sort }, { rejectWithValue }) => {
    try {
      const response = await fetchEmailSchedulesFromAPI(page, perPage, search, columnFilters, sort);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal mengambil data email schedule");
    }
  }
);


export const deleteEmailSchedule = createAsyncThunk(
  "emailSchedules/deleteEmailSchedule",
  async (emailScheduleId, { rejectWithValue }) => {
    try {
      const response = await deleteEmailSchedulesFromAPI(emailScheduleId);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal menghapus data email schedule");
    }
  }
);

// Upload Email Schedule File
export const uploadEmailScheduleFile = createAsyncThunk(
  "emailSchedules/uploadEmailScheduleFile",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await uploadEmailScheduleFileToAPI(formData);
      return response;
    } catch (error) {
      return rejectWithValue({
        message: error?.message || "Upload gagal.",
        detail: error?.detail || [],
        status: error?.status || "failed"
      });
    }
  }
);


const emailScheduleSlice = createSlice({
  name: "emailSchedules",
  initialState: {
    emailSchedules: [],
    currentPage: 1,
    lastPage: 1,
    perPage: 10,
    firstItem: 1,
    totalCount: 0,
    active: 0,
    types: 0,
    emailScheduleSearch: "",
    loading: false,
    error: null,
    keywordSearch: "",
    columnFilters: {}
  },
  reducers: {
    setSearchEmailSchedule: (state, action) => {
      state.emailScheduleSearch = action.payload;
    },
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setKeywordSearch: (state, action) => {
      state.keywordSearch = action.payload;
    },
    setColumnFilters: (state, action) => {
      state.columnFilters = { ...state.columnFilters, ...action.payload };
    },
    resetEmailScheduleState: (state) => {
      state.emailSchedules = [];
      state.currentPage = 1;
      state.lastPage = 1;
      state.perPage = 10;
      state.firstItem = 1;
      state.totalCount = 0;
      state.active = 0;
      state.types = 0;
      state.loading = false;
      state.error = null;
      state.emailScheduleSearch = "";
      state.keywordSearch = "";
      state.columnFilters = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmailSchedules.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmailSchedules.fulfilled, (state, action) => {
        state.loading = false;
        state.emailSchedules = action.payload.data.emailSchedules || [];
        state.currentPage = action.payload.data.pagination?.current_page || 1;
        state.lastPage = action.payload.data.pagination?.last_page || 1;
        state.perPage = action.payload.data.pagination?.per_page || 10;
        state.firstItem = action.payload.data.pagination?.from || 1;
        state.totalCount = action.payload.data.pagination?.total || 0;
        state.active = action.payload.data.active ?? 0;
        state.types = action.payload.data.types ?? 0;
      })
      .addCase(fetchEmailSchedules.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteEmailSchedule.fulfilled, (state, action) => {
        state.emailSchedules = state.emailSchedules.filter((emailSchedule) => emailSchedule.id !== action.meta.arg);
        state.totalCount = Math.max(0, state.totalCount - 1);
      })
      .addCase(deleteEmailSchedule.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(uploadEmailScheduleFile.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadEmailScheduleFile.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(uploadEmailScheduleFile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setSearchEmailSchedule, setPage, setPerPage, setKeywordSearch, setColumnFilters, resetEmailScheduleState } = emailScheduleSlice.actions;
export default emailScheduleSlice.reducer;
